import { ServiceData } from '@/types';

import articles from './LOVE_ARTICLES_FI.json';
import audios from './LOVE_AUDIOS_FI.json';

export const LOVE_DATA_FI: ServiceData = {
  articles,
  audios,
};
